const _this = {

    $dom: {
		
    },

    vars: {
		
	},

    init : function() {
        this.map();
    },

    map: function() {
		(function($){
            // preloader
        
        /*
        *  new_map
        *
        *  This function will render a Google Map onto the selected jQuery element
        *
        *  @type	function
        *  @date	8/11/2013
        *  @since	4.3.0
        *
        *  @param	$el (jQuery element)
        *  @return	n/a
        */
        
        function new_map( $el ) {
            
            // var
            var $markers = $el.find('.marker');
            
            
            // vars
            var args = {
                zoom		: 6,
                center		: new google.maps.LatLng(0, 0),
                mapTypeId	: google.maps.MapTypeId.ROADMAP,
                scrollwheel: false,
                styles: [
                    {
                      "elementType": "geometry",
                      "stylers": [
                        {
                          "color": "#212121"
                        }
                      ]
                    },
                    {
                      "elementType": "labels.icon",
                      "stylers": [
                        {
                          "visibility": "off"
                        }
                      ]
                    },
                    {
                      "elementType": "labels.text.fill",
                      "stylers": [
                        {
                          "color": "#757575"
                        }
                      ]
                    },
                    {
                      "elementType": "labels.text.stroke",
                      "stylers": [
                        {
                          "color": "#212121"
                        }
                      ]
                    },
                    {
                      "featureType": "administrative",
                      "elementType": "geometry",
                      "stylers": [
                        {
                          "color": "#757575"
                        }
                      ]
                    },
                    {
                      "featureType": "administrative.country",
                      "elementType": "labels.text.fill",
                      "stylers": [
                        {
                          "color": "#9e9e9e"
                        }
                      ]
                    },
                    {
                      "featureType": "administrative.locality",
                      "elementType": "labels.text.fill",
                      "stylers": [
                        {
                          "color": "#bdbdbd"
                        }
                      ]
                    },
                    {
                      "featureType": "poi",
                      "elementType": "labels.text.fill",
                      "stylers": [
                        {
                          "color": "#757575"
                        }
                      ]
                    },
                    {
                      "featureType": "poi.park",
                      "elementType": "geometry",
                      "stylers": [
                        {
                          "color": "#181818"
                        }
                      ]
                    },
                    {
                      "featureType": "poi.park",
                      "elementType": "labels.text.fill",
                      "stylers": [
                        {
                          "color": "#616161"
                        }
                      ]
                    },
                    {
                      "featureType": "poi.park",
                      "elementType": "labels.text.stroke",
                      "stylers": [
                        {
                          "color": "#1b1b1b"
                        }
                      ]
                    },
                    {
                      "featureType": "road",
                      "elementType": "geometry.fill",
                      "stylers": [
                        {
                          "color": "#2c2c2c"
                        }
                      ]
                    },
                    {
                      "featureType": "road",
                      "elementType": "labels.text.fill",
                      "stylers": [
                        {
                          "color": "#8a8a8a"
                        }
                      ]
                    },
                    {
                      "featureType": "road.arterial",
                      "elementType": "geometry",
                      "stylers": [
                        {
                          "color": "#373737"
                        }
                      ]
                    },
                    {
                      "featureType": "road.highway",
                      "elementType": "geometry",
                      "stylers": [
                        {
                          "color": "#3c3c3c"
                        }
                      ]
                    },
                    {
                      "featureType": "road.highway.controlled_access",
                      "elementType": "geometry",
                      "stylers": [
                        {
                          "color": "#4e4e4e"
                        }
                      ]
                    },
                    {
                      "featureType": "road.local",
                      "elementType": "labels.text.fill",
                      "stylers": [
                        {
                          "color": "#616161"
                        }
                      ]
                    },
                    {
                      "featureType": "transit",
                      "elementType": "labels.text.fill",
                      "stylers": [
                        {
                          "color": "#757575"
                        }
                      ]
                    },
                    {
                      "featureType": "water",
                      "elementType": "geometry",
                      "stylers": [
                        {
                          "color": "#6c6c6c"
                        }
                      ]
                    },
                    {
                      "featureType": "water",
                      "elementType": "labels.text.fill",
                      "stylers": [
                        {
                          "color": "#3d3d3d"
                        }
                      ]
                    }
                  ]
                   
            };
            
            
            // create map	        	
            var map = new google.maps.Map( $el[0], args);
            
            
            // add a markers reference
            map.markers = [];
            
            
            // add markers
            $markers.each(function(){
                
                add_marker( $(this), map );
                
            });
            
            
            // center map
            center_map( map );
            
            
            // return
            return map;
            
        }
        
        /*
        *  add_marker
        *
        *  This function will add a marker to the selected Google Map
        *
        *  @type	function
        *  @date	8/11/2013
        *  @since	4.3.0
        *
        *  @param	$marker (jQuery element)
        *  @param	map (Google Map object)
        *  @return	n/a
        */
        
        function add_marker( $marker, map ) {
            
            // var
            var latlng = new google.maps.LatLng( $marker.attr('data-lat'), $marker.attr('data-lng') );
        
            // create marker
            var marker = new google.maps.Marker({
                position	: latlng,
                map			: map,
                icon		:"data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTciIGhlaWdodD0iNjQiIHZpZXdCb3g9IjAgMCA1NyA2NCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgb3BhY2l0eT0iMC43IiBmaWx0ZXI9InVybCgjZmlsdGVyMF9mXzI4Nl8yMzg4KSI+CjxwYXRoIGQ9Ik0xOSA1OS4yODUyQzE2Ljc5MDkgNTkuMjg1MiAxNSA1Ny40OTQzIDE1IDU1LjI4NTJWNTUuMjg1MkMxNSA1My4wNzYgMTYuNzkwOSA1MS4yODUyIDE5IDUxLjI4NTJMMzYgNTEuMjg1MkMzOC4yMDkxIDUxLjI4NTIgNDAgNTMuMDc2IDQwIDU1LjI4NTJWNTUuMjg1MkM0MCA1Ny40OTQzIDM4LjIwOTEgNTkuMjg1MiAzNiA1OS4yODUyTDE5IDU5LjI4NTJaIiBmaWxsPSIjMTQxMzEzIi8+CjwvZz4KPHBhdGggZD0iTTE0LjE0MjEgNDIuNDI3M0M2LjMzMTY1IDM0LjYxNjggNi4zMzE2NSAyMS45NTM1IDE0LjE0MjEgMTQuMTQzVjE0LjE0M0MyMS45NTI2IDYuMzMyNTMgMzQuNjE1OSA2LjMzMjUzIDQyLjQyNjQgMTQuMTQzVjE0LjE0M0M1MC4yMzY5IDIxLjk1MzUgNTAuMjM2OSAzNC42MTY4IDQyLjQyNjQgNDIuNDI3M0wyOC4yODQzIDU2LjU2OTRMMTQuMTQyMSA0Mi40MjczWiIgZmlsbD0iIzIzNkRCMCIvPgo8cGF0aCBkPSJNMjggMzkuMDEzN0MyMi40NzcyIDM5LjAxMzcgMTggMzQuNTM2NSAxOCAyOS4wMTM3VjI5LjAxMzdDMTggMjMuNDkwOCAyMi40NzcyIDE5LjAxMzcgMjggMTkuMDEzN1YxOS4wMTM3QzMzLjUyMjggMTkuMDEzNyAzOCAyMy40OTA4IDM4IDI5LjAxMzdWMjkuMDEzN0MzOCAzNC41MzY1IDMzLjUyMjggMzkuMDEzNyAyOCAzOS4wMTM3VjM5LjAxMzdaIiBmaWxsPSIjRTlFRkY3Ii8+CjxkZWZzPgo8ZmlsdGVyIGlkPSJmaWx0ZXIwX2ZfMjg2XzIzODgiIHg9IjExIiB5PSI0Ny4yODUyIiB3aWR0aD0iMzMiIGhlaWdodD0iMTYiIGZpbHRlclVuaXRzPSJ1c2VyU3BhY2VPblVzZSIgY29sb3ItaW50ZXJwb2xhdGlvbi1maWx0ZXJzPSJzUkdCIj4KPGZlRmxvb2QgZmxvb2Qtb3BhY2l0eT0iMCIgcmVzdWx0PSJCYWNrZ3JvdW5kSW1hZ2VGaXgiLz4KPGZlQmxlbmQgbW9kZT0ibm9ybWFsIiBpbj0iU291cmNlR3JhcGhpYyIgaW4yPSJCYWNrZ3JvdW5kSW1hZ2VGaXgiIHJlc3VsdD0ic2hhcGUiLz4KPGZlR2F1c3NpYW5CbHVyIHN0ZERldmlhdGlvbj0iMiIgcmVzdWx0PSJlZmZlY3QxX2ZvcmVncm91bmRCbHVyXzI4Nl8yMzg4Ii8+CjwvZmlsdGVyPgo8L2RlZnM+Cjwvc3ZnPgo="
            });
        
            // add to array
            map.markers.push( marker );
        
            // if marker contains HTML, add it to an infoWindow
            if( $marker.html() )
            {
                // create info window
                var infowindow = new google.maps.InfoWindow({
                    content		: $marker.html()
                });
        
                // show info window when marker is clicked
                google.maps.event.addListener(marker, 'click', function() {
        
                    infowindow.open( map, marker );
        
                });
            }
        
        }
        
        /*
        *  center_map
        *
        *  This function will center the map, showing all markers attached to this map
        *
        *  @type	function
        *  @date	8/11/2013
        *  @since	4.3.0
        *
        *  @param	map (Google Map object)
        *  @return	n/a
        */
        
        function center_map( map ) {
        
            // vars
            var bounds = new google.maps.LatLngBounds();
        
            // loop through all markers and create bounds
            $.each( map.markers, function( i, marker ){
        
                var latlng = new google.maps.LatLng( marker.position.lat(), marker.position.lng() );
        
                bounds.extend( latlng );
        
            });
        
            // only 1 marker?
            if( map.markers.length == 1 )
            {
                // set center of map
                map.setCenter( bounds.getCenter() );
                map.setZoom( 15 );
            }
            else
            {
                // fit to bounds
                map.fitBounds( bounds );
            }
        
        }
        
        /*
        *  document ready
        *
        *  This function will render each map when the document is ready (page has loaded)
        *
        *  @type	function
        *  @date	8/11/2013
        *  @since	5.0.0
        *
        *  @param	n/a
        *  @return	n/a
        */
        // global var
        var map = null;
        
        $(document).ready(function(){
        
            $('.acf-map').each(function(){
        
                // create map
                map = new_map( $(this) );
        
            });
        
        });
        
        })(jQuery);
            
            
        
	}
}

export default _this;